/* Import Estilo */
import './index.scss';

/* Import Bibliotecas */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/* Import Contextos */
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';

/* Import Componentes */
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';

/* Import Requisição API */
import api from '../../api';

export default function EscreverAvaliacaoSite() {
    const navigate = useNavigate();
    const { userId } = useAuth();
    const { showToast } = useToast();

    const [notaSelecionada, setNotaSelecionada] = useState(0);
    const [notaHover, setNotaHover] = useState(0);
    const [comentario, setComentario] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [erro, setErro] = useState('');
    const [podeAvaliar, setPodeAvaliar] = useState(null);

    /* Redireciona se não autenticado */
    useEffect(() => {
        if (userId === null) {
            navigate('/login');
        }
    }, [userId, navigate]);

    /* Verifica se o usuário já fez pelo menos um pedido */
    useEffect(() => {
        if (!userId) return;
        api.get('/avaliacoes-site/pode-avaliar')
            .then(res => {
                if (!res.data.podeAvaliar) {
                    showToast('Você precisa ter feito pelo menos um pedido para avaliar a loja.', 'error');
                    navigate('/avaliacoes-site');
                } else {
                    setPodeAvaliar(true);
                }
            })
            .catch(() => setPodeAvaliar(true));
    }, [userId, navigate, showToast]);

    const notaAtiva = notaHover || notaSelecionada;

    const labelNota = (n) => {
        const labels = ['', 'Péssimo', 'Ruim', 'Regular', 'Bom', 'Excelente'];
        return labels[n] || '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');

        if (!notaSelecionada) {
            setErro('Selecione uma nota de 1 a 5 estrelas.');
            return;
        }

        setEnviando(true);
        try {
            const res = await api.post('/avaliacoes-site', {
                nota: notaSelecionada,
                comentario: comentario.trim() || undefined,
            });
            if (res.data.success) {
                showToast('Avaliação enviada com sucesso! Obrigado.', 'success');
                navigate('/avaliacoes-site');
            }
        } catch (err) {
            const msg = err?.response?.data?.message || 'Erro ao enviar avaliação.';
            setErro(msg);
        } finally {
            setEnviando(false);
        }
    };

    /* Ainda não sabemos o estado de auth ou permissão */
    if (userId === undefined || podeAvaliar === null) return null;

    return (
        <div className="escrever-avaliacao-page">
            <Cabecalho />

            <main className="escrever-avaliacao-main">
                <div className="form-card">
                    <button className="btn-voltar-texto" onClick={() => navigate('/avaliacoes-site')}>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.3657 15.1657C10.2157 15.3156 10.0122 15.3999 9.8001 15.3999C9.58797 15.3999 9.38452 15.3156 9.2345 15.1657L5.6345 11.5657C5.48452 11.4157 5.40027 11.2122 5.40027 11.0001C5.40027 10.7879 5.48452 10.5845 5.6345 10.4345L9.2345 6.83447C9.38538 6.68875 9.58746 6.60811 9.79722 6.60993C10.007 6.61176 10.2076 6.69589 10.356 6.84422C10.5043 6.99254 10.5884 7.1932 10.5902 7.40295C10.5921 7.61271 10.5114 7.81479 10.3657 7.96567L8.2001 10.2001L15.8001 10.2001C16.0123 10.2001 16.2158 10.2844 16.3658 10.4344C16.5158 10.5844 16.6001 10.7879 16.6001 11.0001C16.6001 11.2122 16.5158 11.4157 16.3658 11.5658C16.2158 11.7158 16.0123 11.8001 15.8001 11.8001L8.2001 11.8001L10.3657 14.0345C10.5157 14.1845 10.5999 14.3879 10.5999 14.6001C10.5999 14.8122 10.5157 15.0157 10.3657 15.1657Z" fill="black" stroke="black"/>
                            <circle cx="11" cy="11" r="9.25" stroke="black" strokeWidth="2.5"/>
                        </svg>
                        Ver avaliações
                    </button>

                    <h1 className="form-titulo">Avaliar a Fracaro Store</h1>
                    <p className="form-subtitulo">
                        Sua opinião é muito importante para nós. Conte como foi a sua experiência.
                    </p>

                    <form onSubmit={handleSubmit} className="form-avaliacao">
                        {/* Seletor de estrelas */}
                        <div className="campo-grupo">
                            <label className="campo-label">Nota *</label>
                            <div className="estrelas-seletor">
                                {[1, 2, 3, 4, 5].map(i => (
                                    <button
                                        key={i}
                                        type="button"
                                        className={`estrela-btn ${i <= notaAtiva ? 'ativa' : ''}`}
                                        onMouseEnter={() => setNotaHover(i)}
                                        onMouseLeave={() => setNotaHover(0)}
                                        onClick={() => setNotaSelecionada(i)}
                                        aria-label={`${i} ${i === 1 ? 'estrela' : 'estrelas'}`}
                                    >
                                        <svg
                                            width="40"
                                            height="40"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                        </svg>
                                    </button>
                                ))}
                            </div>
                            {notaAtiva > 0 && (
                                <span className="nota-label">{labelNota(notaAtiva)}</span>
                            )}
                        </div>

                        {/* Comentário */}
                        <div className="campo-grupo">
                            <label className="campo-label" htmlFor="comentario">
                                Comentário (opcional)
                            </label>
                            <textarea
                                id="comentario"
                                className="campo-textarea"
                                placeholder="Conte sua experiência com a Fracaro Store..."
                                value={comentario}
                                onChange={e => setComentario(e.target.value)}
                                rows={5}
                                maxLength={1000}
                            />
                            <span className="char-count">{comentario.length}/1000</span>
                        </div>

                        {/* Mensagem de erro */}
                        {erro && <p className="form-erro">{erro}</p>}

                        {/* Botão de envio */}
                        <button
                            type="submit"
                            className="btn-enviar"
                            disabled={enviando}
                        >
                            {enviando ? 'Enviando...' : 'Enviar avaliação'}
                        </button>
                    </form>
                </div>
            </main>

            <Rodape />
        </div>
    );
}
